import { SET_VIEWUSERLIST } from '../actions';

const userlistview = (state = [], action) => {
  switch (action.type) {
	case SET_VIEWUSERLIST:
      return [...action.value];  
    default: return state;
  }
}

export default userlistview;
